<template>
    <div>
        <div class="wp-10 p-2 br mb-0 gray-0-bkg flex-row" style="justify-content: space-between">
            <el-input
                ref="search-input"
                v-model="searchTxt"
                :placeholder="placeholder"
                suffixIcon="icon-search black pl-2"
                class="w-4"
                @keyup.enter.native="process()"
            />
            <span class="label-number">{{ getFilterData.length }} {{ rowNumberLabel }}</span>
        </div>

        <el-table
            id="simple-list-table"
            :data="getFilterData"
            :defaultSort="{ prop: columns[0].name, order: 'ascending' }"
            class="table-simple-list"
            style="height: calc(100% - 240px); overflow: auto"
        >
            <el-table-column
                v-for="(column, index) in columns"
                :key="index"
                :prop="column.name"
                :label="column.label"
                :width="column.width"
                :sortable="column.sortable"
            >
                <template slot-scope="scope">
                    <router-link
                        :to="getRowLink(scope.row)"
                        target="_blank"
                        class="flex-row wp-10 simple-list-row"
                        :class="`${column.isLink ? 'row-link' : ''}`"
                    >
                        <icon-svg
                            v-if="column.name === 'name'"
                            class="mr-2"
                            :iconName="field"
                            :width="32"
                            :height="32"
                            viewBox="0 0 32 32"
                        >
                            <component :is="'icon-' + field"></component>
                        </icon-svg>
                        <span v-if="!column.isDate" style="align-self: center">
                            {{ scope.row[column.name] }}
                        </span>
                        <span v-if="column.isDate" style="align-self: center">
                            <span v-if="scope.row[column.name]">
                                {{ scope.row[column.name] | dateFormatter('DASHED_DATE', false) }}
                            </span>
                        </span>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconRapport from 'vcomponents/icons/iconRapport.vue';

export default {
    components: {
        IconSvg,
        IconRapport,
    },
    props: {
        datas: {
            type: Array,
            required: true,
            default: () => [],
        },
        columns: {
            type: Array,
            required: true,
            default: () => [],
        },
        field: {
            type: String,
            required: false,
            default: 'rapport',
        },
        rowNumberLabel: {
            type: String,
            required: false,
            default: 'Items',
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Rechercher',
        },
        cumulioAuth: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            searchTxt: '',
        };
    },
    computed: {
        getFilterData() {
            function compare(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            return this.datas
                .filter((item) => {
                    return item.name.toLowerCase().includes(this.searchTxt.toLowerCase());
                })
                .sort(compare);
        },
    },
    methods: {
        getRowLink(row) {
            if (row.type === 'cumulio') {
                return {
                    name: 'reports.cumulio',
                    params: { id: row.dashboard_id, cumulAuth: this.cumulioAuth, title: row.name },
                };
            }
            return row.path;
        },
    },
};
</script>
<style lang="scss" scoped>
.label-number {
    margin: 8px 0 8px;
    font-weight: 600;
    font-size: 14px;
}
.row-link {
    color: var(--colors-common-text-standard-default);
    cursor: pointer;
}
.table-simple-list {
    &::v-deep {
        .caret-wrapper {
            position: relative !important;
        }
    }
}
.table-simple-list::before {
    &::v-deep {
        height: 0;
    }
}
</style>
